import { render, staticRenderFns } from "./ajax-pagination.vue?vue&type=template&id=65dbd567&"
import script from "./ajax-pagination.vue?vue&type=script&lang=js&"
export * from "./ajax-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports